import axios from 'axios';
import { generateToken } from './otp-function';

const getDistinctCategory = async () => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',
      data: {
        endPoint: 'distinct-category',
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);

    return resp?.primary_category_name;
  } catch (error) {
    throw error;
  }
};

const getDistinctCategorySubCategory = async () => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',
      data: {
        endPoint: 'distinct-category-subcategory',
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);

    // Need to add the success message and functionality
    return resp;
  } catch (error) {
    throw error;
  }
};

const getDistinctColorAndRisk = async () => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',
      data: {
        endPoint: 'distinct-color-and-risk',
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);
    return resp;
  } catch (error) {
    throw error;
  }
};

const getMutualFundSchemeDetail = async () => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',
      data: {
        endPoint: 'mutual-fund-scheme-details',
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);
    return resp?.mutual_fund_scheme_details;
  } catch (error) {
    throw error;
  }
};
const getFundSchemeDetail = async (plan_id) => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',
      data: {
        planId: plan_id,
        endPoint: 'scheme-details',
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);
    return resp?.scheme_details;
  } catch (error) {
    throw error;
  }
};

const getFundGraphDetail = async (plan_id) => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',
      data: {
        planId: plan_id,
        endPoint: 'mutual-fund-details',
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);
    return resp?.mutual_fund_details[0];
  } catch (error) {
    throw error;
  }
};

const getFundGraphData = async (plan_id) => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',
      data: {
        planId: plan_id,
        endPoint: 'get-nav-and-nav-date',
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);
    return resp?.nav_and_nav_date;
  } catch (error) {
    throw error;
  }
};

const getFundManagerData = async (plan_id) => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',
      // url: `${process.env.REACT_APP_MF_VRO_URL}` + 'fund-manager-information',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        planId: plan_id,
        endPoint: 'fund-manager-information',
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);
    return resp?.fund_manager_information;
  } catch (error) {
    throw error;
  }
};

const getPerformanceRatiosData = async (plan_id) => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',
      // url: `${process.env.REACT_APP_MF_VRO_URL}` + 'fund-adv-performance',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        planId: plan_id,
        endPoint: 'fund-adv-performance',
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);
    return resp?.fund_advanced_performance_data;
  } catch (error) {
    throw error;
  }
};

const getPerformanceData = async (plan_id, category_id) => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',
      // url: `${process.env.REACT_APP_MF_VRO_URL}` + 'performance',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        planId: plan_id,
        endPoint: 'performance',
        category_id: category_id,
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);
    return resp;
  } catch (error) {
    throw error;
  }
};

const getAssetAllocationData = async (plan_id) => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',

      // url: `${process.env.REACT_APP_MF_VRO_URL}` + 'asset-allocation',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        planId: plan_id,
        endPoint: 'asset-allocation',
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);
    return resp?.asset_allocation;
  } catch (error) {
    throw error;
  }
};

const getAssetAllocationCompanyAndHoldingData = async (plan_id, asset_class) => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        planId: plan_id,
        endPoint: 'companies-hold-inst-data',
        asset_class: asset_class,
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);
    return resp;
  } catch (error) {
    throw error;
  }
};

const getAssetAllocationMarketCapitalData = async (plan_id) => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',

      // url: `${process.env.REACT_APP_MF_VRO_URL}` + 'market-cap-data',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        planId: plan_id,
        endPoint: 'market-cap-data',
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);
    return resp?.market_cap_data;
  } catch (error) {
    throw error;
  }
};

const getAssetAllocationTopSectorData = async (plan_id) => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',
      // url: `${process.env.REACT_APP_MF_VRO_URL}` + 'top-sectors',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        planId: plan_id,
        endPoint: 'top-sectors',
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);
    return resp;
  } catch (error) {
    throw error;
  }
};
const getFundHouseInvestmentObjData = async (plan_id) => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',
      // url: `${process.env.REACT_APP_MF_VRO_URL}` + 'fund-house-and-investment-obj',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        planId: plan_id,
        endPoint: 'fund-house-and-investment-obj',
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);
    return resp?.fund_house_and_investment_objectives;
  } catch (error) {
    throw error;
  }
};

const getSIPCalculatorData = async (plan_id) => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',

      // url: `${process.env.REACT_APP_MF_VRO_URL}` + 'get-sip-calculator-data',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        planId: plan_id,
        endPoint: 'get-sip-calculator-data',
      },
    };

    let response = await axios.request(formSubmitConfig);
    let resp = JSON.parse(response?.data);
    return resp?.sip_calculator_data;
  } catch (error) {
    throw error;
  }
};

const getLumsumCalculatorData = async (plan_id) => {
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}` + 'api/sitecore/Widget/MutualFundApi',

      // url: `${process.env.REACT_APP_MF_VRO_URL}` + 'return-calculator',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        planId: plan_id,
        endPoint: 'return-calculator',
      },
    };

    let response = await axios.request(formSubmitConfig);

    let resp = JSON.parse(response?.data);
    return resp?.return_calculator;
  } catch (error) {
    throw error;
  }
};

const getSIPCalculatedData = async () => {
  //monthlyInvestAmt, expectedAnnualReturns, investedPeriod
  try {
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      // url: `${process.env.REACT_APP_MF_VRO_URL}` + 'fund-house-and-investment-obj',
      url: 'https://abcduat1.abcscuat.com/abc-securities/api/v1/mutualfund/sip-calculator',
      headers: {
        'auth-token': 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
      data: {
        customerId: 25,
        monthlyInvestAmt: 50000,
        expectedAnnualReturns: 11.31,
        investedPeriod: 5,
      },
    };

    let response = await axios.request(formSubmitConfig);
    return response?.data?.fund_house_and_investment_objectives;
  } catch (error) {
    throw error;
  }
};

const generateTokenMF = async (mobileNo) => {
  try {
    const formSubmitConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_MF_CALC_GENERATE_TOKEN_URL}/generatetoken?mobileNumber=${mobileNo}&key=${process.env.REACT_APP_MF_CALC_GENERATE_TOKEN_KEY}`,
      headers: {
        Cookie: `${process.env.REACT_APP_MF_CALC_GENERATE_TOKEN_COOKIE}`,
        'Content-Type': 'application/json',
      },
      data: {
        plan_id: plan_id,
      },
    };

    let response = await axios.request(formSubmitConfig);

    return response?.data?.return_calculator;
  } catch (error) {
    throw error;
  }
};

const getPeriodWise_SIPCalculationData = async (
  mobileNo,
  investmentAmount,
  period,
  expectedReturns
) => {
  try {
    const token = await generateTokenMF(mobileNo);
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_MF_VRO_URL}` + '/sip-calculator',
      headers: {
        Authorization: 'Bearer ' + token,
        Cookie: `${process.env.REACT_APP_MF_PRODUCT_RETURN_CALC_URL_COOKIE}`,
        'Content-Type': 'application/json',
      },
      data: {
        customerId: '',
        monthlyInvestAmt: investmentAmount,
        expectedAnnualReturns: expectedReturns,
        investedPeriod: period,
      },
    };

    let response = await axios.request(formSubmitConfig);

    return response?.data;
  } catch (error) {
    throw error;
  }
};

const getPeriodWise_LumpSumCalculationData = async (
  mobileNo,
  investmentAmount,
  period,
  expectedReturns
) => {
  try {
    const token = await generateTokenMF(mobileNo);
    const formSubmitConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_MF_VRO_URL}` + '/lumpsum-calculator',
      headers: {
        Authorization: 'Bearer ' + token,
        Cookie: `${process.env.REACT_APP_MF_PRODUCT_RETURN_CALC_URL_COOKIE}`,
        'Content-Type': 'application/json',
      },
      data: {
        lumpsumAmt: investmentAmount,
        expectedReturn: expectedReturns,
        investmentPeriod: period,
      },
    };

    let response = await axios.request(formSubmitConfig);

    return response?.data;
  } catch (error) {
    throw error;
  }
};

export {
  getDistinctCategory,
  getDistinctCategorySubCategory,
  getDistinctColorAndRisk,
  getMutualFundSchemeDetail,
  getFundSchemeDetail,
  getFundGraphDetail,
  getFundGraphData,
  getFundManagerData,
  getPerformanceRatiosData,
  getPerformanceData,
  getAssetAllocationData,
  getAssetAllocationCompanyAndHoldingData,
  getAssetAllocationMarketCapitalData,
  getAssetAllocationTopSectorData,
  getFundHouseInvestmentObjData,
  getSIPCalculatorData,
  getSIPCalculatedData,
  getLumsumCalculatorData,
  getPeriodWise_SIPCalculationData,
  getPeriodWise_LumpSumCalculationData,
};
